import ajax from "../helpers/ajax";
import StoreContainer from "../stores/StoreContainer";

class CobrowseService {
  static async declineRequest(engagementId: string) {
    const endpoint = StoreContainer.SettingStore.getEngagementHubEndpoint();
    const siteId = StoreContainer.SettingStore.getSiteId();

    return await ajax({
      url: `${endpoint}/v1/${siteId}/Cobrowse/Decline`,
      method: "post",
      data: { engagementId }
    });
  }

  static async acceptRequest(engagementId: string) {
    const endpoint = StoreContainer.SettingStore.getEngagementHubEndpoint();
    const siteId = StoreContainer.SettingStore.getSiteId();

    return await ajax({
      url: `${endpoint}/v1/${siteId}/Cobrowse/Accept`,
      method: "post",
      data: { engagementId }
    });
  }

  static async stopSession(engagementId: string) {
    const endpoint = StoreContainer.SettingStore.getEngagementHubEndpoint();
    const siteId = StoreContainer.SettingStore.getSiteId();

    return await ajax({
      url: `${endpoint}/v1/${siteId}/Cobrowse/Stop`,
      method: "post",
      data: { engagementId }
    });
  }
}

export default CobrowseService;
